export default "__VITE_ASSET__DEEMxl4p__"